export default "__VITE_ASSET__CEbYoQxz__"